import { Vendor, VendorType } from "../types";
import {
  Button,
  Dialog,
  DialogContent,
  useMediaQuery,
} from "@mui/material";
import InfoRow from "./InfoRow";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import LanguageIcon from '@mui/icons-material/Language';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import InstagramIcon from '@mui/icons-material/Instagram';

interface Props {
  open: boolean;
  vendor?: Vendor;
  vendorType: VendorType;
  closeModal: () => void;
}

function VendorModal(props: Props) {
  const { open, vendor, closeModal, vendorType } = props;
  const isDesktop = useMediaQuery("(min-width: 720px)");


  return (
    <Dialog
      fullWidth
      open={open}
      onClose={closeModal}
      PaperProps={{
        sx: {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      <DialogContent
        sx={{
          padding: 0,
          overflowY: "auto",
          borderRadius: isDesktop ? "50px" : "25px",
        }}
      >
        <div className="vendor-modal">
          <div className="left-container">
            <img
              src={vendor?.logo ?? vendorType.logo ?? undefined}
              className="logo"
              alt=""
            />
          </div>

          <div className="right-container">
            <h3 className="vendor-name">{vendor?.name}</h3>

            {vendor?.description && (
              <h3 className="vendor-description">{vendor?.description}</h3>
            )}

            <div className="info-container">
              <InfoRow IconSrc={LocationOnIcon} value={vendor?.located ?? '-'} type="located" />
              {vendor?.phone && <InfoRow IconSrc={PhoneIcon} value={vendor.phone} type="phone" />}
              {vendor?.link && <InfoRow IconSrc={LanguageIcon} value={vendor.link} type="link" />}

              {vendor?.email && <InfoRow IconSrc={MailOutlineIcon} value={vendor.email} type="email" />}
              {vendor?.instagram && <InfoRow IconSrc={InstagramIcon} value={vendor.instagram} type="instagram" />}
            </div>
          </div>
          <div className="close-button">
            <Button
              sx={{
                fontFamily: 'Belleza',
                letterSpacing: '2px',
                backgroundColor: 'rgb(44, 34, 24)', // Changed background color
                color: '#fff', // Optional: white text for contrast
                borderColor: '#19130e', // Optional: match border to background
                '&:hover': {
                  backgroundColor: '#2c2218', // Slightly lighter on hover
                  borderColor: '#2c2218',
                },
              }}
              onClick={closeModal}
              variant="outlined"
            >
              Close
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default VendorModal;
